<div class="row g-0">
  <div class="col-auto">
    <h5 class="my-1">
      <div class="d-flex">
        <div><mat-icon class="material-icons-round">file_present</mat-icon></div>
        <div>{{ patientAttachment.fileName }}</div>
      </div>
    </h5>
  </div>
  <div class="col">
    <nav class="nav nav-pills d-flex flex-wrap justify-content-end">
      <app-user-presence category="consultNote" [targetId]="patientAttachment.id" class="me-2" />
      <a
        class="nav-item nav-link"
        routerLink="/capture-admin/consult-notes/{{patientAttachment.id}}"
        routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: true }"
      >
        <div class="d-flex">
          <mat-icon class="material-icons-round">fact_check</mat-icon>
          <div class="nav-text">Consult Note Details</div>
        </div>
      </a>
      <a
        class="nav-item nav-link"
        routerLink="/capture-admin/consult-notes/{{patientAttachment.id}}/history"
        routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: true }"
      >
        <div class="d-flex">
          <mat-icon class="material-icons-round">fact_check</mat-icon>
          <div class="nav-text">Consult Note History</div>
        </div>
      </a>
      <a
        class="nav-item nav-link"
        routerLink="/capture-admin/consult-notes/{{patientAttachment.id}}/prescriptions"
        routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: true }"
      >
        <div class="d-flex">
          <mat-icon class="material-icons-round">local_pharmacy</mat-icon>
          <div class="nav-text">Prescriptions</div>
        </div>
      </a>
      <a
        class="nav-item nav-link"
        routerLink="/capture-admin/consult-notes/{{patientAttachment.id}}/related"
        routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: true }"
      >
        <div class="d-flex">
          <mat-icon class="material-icons-round">book</mat-icon>
          <div class="nav-text">Related Consult Notes</div>
        </div>
      </a>
      <a
        class="nav-item nav-link"
        routerLink="/capture-admin/consult-notes/{{patientAttachment.id}}/captures"
        routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: true }"
      >
        <div class="d-flex">
          <mat-icon class="material-icons-round">check_circle</mat-icon>
          <div class="nav-text">Verified Captures</div>
        </div>
      </a>
    </nav>
  </div>
</div>
